import PageHero from "@/components/layout/PageHero";
import SEO from "@/components/layout/SEO";
import FeatureList from "@/components/layout/FeatureList";
import EnglishExamCrossSell from "@/components/layout/EnglishExamCrossSell";
import EntryExamCrossSell from "@/components/layout/EntryExamCrossSell";
import EligibilitySection from "@/components/home/EligibilitySection";
import FinalCTA from "@/components/home/FinalCTA";
import { IMG, BOOKING_URLS } from "@/lib/content";

const ITEMS = [
  { title: "Program matching", body: "Identify Master's programs that align with your background, goals and intended career." },
  { title: "Tuition & scholarships", body: "Compare costs across public and private universities, plus NAWA and university scholarships." },
  { title: "Documents, translated right", body: "Transcripts, recognition, apostille, English certificates — prepared cleanly, once." },
  { title: "Visa & relocation logic", body: "How the timeline really flows — admission letter → visa → arrival → residence card." },
];

export default function Master() {
  return (
    <div data-testid="page-master">
      <SEO
        title="Master's degrees in Poland — strategy & scholarships"
        description="Strategic program matching, scholarship routing and visa sequencing for international Master's candidates applying to Polish universities."
        path="/master"
      />
      <PageHero
        overline="Master in Poland"
        title={<>Master in Poland — the <span className="italic text-[#D7141A]">right program</span>, not the easiest one.</>}
        subtitle="Strategic program matching, scholarship routing and visa sequencing for serious Master's candidates."
        image={IMG.library}
        ctaPrimary={{ to: BOOKING_URLS.master, label: "Book Strategy Call" }}
        ctaSecondary={{ to: "/free-resources", label: "Free Starter Guide" }}
      />
      <FeatureList
        overline="Master support"
        title="A real plan from application to arrival."
        intro="We help you make decisions you won't regret at orientation."
        items={ITEMS}
      />
      <EnglishExamCrossSell
        level="B2 / C1"
        context="Most Master programs in Poland require"
        testId="master-english-cross-sell"
      />
      <EntryExamCrossSell
        context="Many Master programs in Poland include"
        note="Common for competitive tracks — non-OECD applicants should plan for it."
        testId="master-entry-exam-cross-sell"
      />
      <EligibilitySection />
      <FinalCTA />
    </div>
  );
}
